<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="administration-create-user-title">
      {{ $t('administration.users.create.title') }}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-user-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-user-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-user-name-label">
                  {{ $t('administration.users.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-user-form-name"
                  type="text"
                  v-model="userForm.name"
                  required
                  :placeholder="$t('administration.users.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-user-email-label">
                  {{ $t('administration.users.create.email_label') }}
                </label>
                <b-form-input
                  qid="create-user-form-email"
                  type="email"
                  v-model="userForm.email"
                  required
                  :placeholder="$t('administration.users.create.email_label')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-user-phone-label">
                  {{ $t('administration.users.create.phone_label') }}
                </label>
                <b-form-input
                  type="text"
                  qid="create-user-form-phone"
                  v-model="userForm.phone"
                  :placeholder="$t('administration.users.create.phone_label')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-user-cancel-button"
              >
                {{ $t('administration.users.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        :disabled="buttonDisabled"
                        variant="success"
                        qid="create-user-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('administration.users.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateUser',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('administration.title'),
            to: '/administration'
          },
          {
            text: this.$t('administration.users.title'),
            to: '/administration/users'
          },
          {
            text: this.$t('administration.users.create.title'),
            active: true
          }
        ],
        userForm: {
          name: '',
          email: '',
          phone: '',
          authentication: 'Application'
        },
        error: '',
        buttonDisabled: false
      }
    },
    computed: {

    },
    methods: {
      goToList() {
        this.$router.push('/administration/users')
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        piincHttp.post('users', this.userForm).then(function(response) {
          self.$toastr('success', self.$t('administration.users.create.success'))
          self.buttonDisabled = false;
          self.goToList();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.email) {
              self.error += ' ' + error.data.errors.email[0]
            }
          }
        })
      },
    },
    components: {

    },
    created () {

    }
  }
</script>
